import Vue from "vue";
let vue = new Vue()
vue.currentSpar = {}
vue.bracelets = [];
vue.sizeIndex = 0;
export default vue;